import React from "react";
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { APIKEYGOOGLE } from '../utils';

const GeoLocation = (props) => {
  const mapStyles = {
    width: '100%',
    height: '80vh',
  };

  return (
    <Map
      google={props.google}
      zoom={props.zoom}
      style={mapStyles}
      initialCenter={{
        lat: props.center.lat,
        lng: props.center.lng,
      }}
    >
      <Marker position={{
        lat: props.center.lat,
        lng: props.center.lng
      }}
      />
    </Map>
  );
}

export default GoogleApiWrapper({
  apiKey: APIKEYGOOGLE,
})(GeoLocation);